import React, { useState } from "react";
import {
  BackgroundColorContext,
  backgroundColors,
} from "contexts/BackgroundColorContext";

export const SIDEBAR_STORAGE_KEY = "sistema-pedidos-sidebar";

export const readStoredSidebarColor = () => {
  try {
    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    if (Object.values(backgroundColors).includes(stored)) return stored;
  } catch (e) {
    // ignore
  }
  return backgroundColors.primary;
};

export default function BackgroundColorWrapper(props) {
  const [color, setColor] = useState(readStoredSidebarColor);

  function changeColor(nextColor) {
    setColor(nextColor);
    try {
      localStorage.setItem(SIDEBAR_STORAGE_KEY, nextColor);
    } catch (e) {
      // ignore
    }
  }

  return (
    <BackgroundColorContext.Provider value={{ color, changeColor }}>
      {props.children}
    </BackgroundColorContext.Provider>
  );
}
